import Utils from '../utils/util';
import { getCubeDataType } from './cubeType';

// 立式货架源数据
export function isShelfCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'shelf';
}

// 卧柜源数据
export function isFreezerCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'freezer';
}

// 卧柜层板源数据
export function isCabinetCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'cabinet';
}

// 层板源数据
export function isLayerCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'layer';
}

// 顶板源数据
export function isRoofCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'roof';
}

// 横杆源数据
export function isBeamCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'beam';
}

// 碗碟架源数据
export function isDishrackCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'dishrack';
}

// 商品源数据
export function isGoodsCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'goods';
}

// 隔板源数据
export function isBafflePlateCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'bafflePlate';
}

// 文本框源数据
export function isTextareaCubeData(cubeData: FreeObjMap): boolean {
    return getCubeDataType(cubeData) === 'textarea';
}

// 层板类型
export function isPartitionCubeData(cubeData: FreeObjMap): boolean {
    return isDishrackCubeData(cubeData)
        || isBeamCubeData(cubeData)
        || isRoofCubeData(cubeData)
        || isLayerCubeData(cubeData)
        || isCabinetCubeData(cubeData);
}

export function goodsInfoHasSizeError(cubeData: FreeObjMap): boolean {
    if (!(cubeData.goods && cubeData.goods[0] && cubeData.goods[0].wareInfoVO)) {
        return true;
    }
    let skuInfo: FreeObjMap = cubeData.goods[0].wareInfoVO;
    let width: PhysicsMeasurement = Utils.toNumberForce(skuInfo.width);
    let height: PhysicsMeasurement = Utils.toNumberForce(skuInfo.height);
    let depth: PhysicsMeasurement = Utils.toNumberForce(skuInfo.depth);

    if (width > 0 && height > 0 && depth > 0) {
        return false;
    }

    return true;
}
